import * as React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  label?: string;
};

export function GreenSpinnerOverlay({ open, label }: Props) {
  const { t } = useTranslation();

  const resolvedLabel =
    label ?? t("onboarding.common.submitting", "Submitting…");

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (t) => t.zIndex.modal + 1,
        bgcolor: "rgba(255,255,255,0.75)",
        backdropFilter: "blur(6px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
          p: 3,
          borderRadius: "20px",
          bgcolor: "rgba(255,255,255,0.92)",
          boxShadow: "0 16px 40px rgba(15, 23, 42, 0.14)",
          border: "1px solid rgba(228, 237, 245, 0.9)",
          minWidth: 260,
        }}
      >
        <CircularProgress
          thickness={4}
          sx={{
            color: "#6CCB8B",
          }}
        />

        {resolvedLabel && (
          <Typography
            sx={{
              color: "#1A1A1A",
              fontWeight: 600,
              fontSize: 14,
              textAlign: "center",
            }}
          >
            {resolvedLabel}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
}
